import React, { useEffect, useState, useMemo, useCallback, useContext, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { LayoutContext } from '../Context/LayoutContext';
import { Dialog, DialogTitle, DialogContent, DialogActions, Typography } from '@mui/material';

import {
  Menu,
  MenuItem,
  IconButton,
  InputBase,
  styled,
  alpha,
  Tooltip,
  Paper,
  MenuList,
  Popper,
  Drawer,
} from '@mui/material';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import {
  AccountCircleOutlined as AccountIcon,
  Logout as LogoutIcon,
  Menu as MenuIcon,
  Close as CloseIcon,
  Search as SearchIcon,
  ExpandMore as ExpandMoreIcon,
} from '@mui/icons-material';
import { useThemeColors } from '../Context/Theme';
import cart from '../Images/ic-cart.png';
import profile from '../Images/ic-user.png';
import profile1 from '../Images/ic-user-black.png';
import './CSS/navbar.css';
import { useAutocomplete } from '@mui/base/useAutocomplete';
import CustomButton from './CustomButton';
import {
  FADE_BLACK,
  GRAY_DARK,
  ORDERTHAT_RED,
  PRIMARY,
  SEARCH_BACKGROUND,
  SEARCH_BORDER,
  SEARCH_COLOR,
  WHITE,
} from '../styles/color';
import AccountCircleOutlinedIcon from '@mui/icons-material/AccountCircleOutlined';
import ShoppingCartOutlinedIcon from '@mui/icons-material/ShoppingCartOutlined';
import LoginIcon from '@mui/icons-material/Login';
import PersonAddIcon from '@mui/icons-material/PersonAdd';
import NotificationsNoneOutlinedIcon from '@mui/icons-material/NotificationsNoneOutlined';
import LocalActivityOutlinedIcon from '@mui/icons-material/LocalActivityOutlined';
import { red } from '@mui/material/colors';
import { useDispatch, useSelector } from 'react-redux';
import { clearCart } from '../Features/services/cartSlice';
import { logoutUser, logout, clearUserLoginHint } from '../Features/Auth/AuthSlice';
import API_URL from '../ServiceModule/Service';
import axios from 'axios';
import {
  useGetAPIQuery,
  useGetAPIWithoutTokenQuery,
  usePostAPIWithOutTokenMutation,
  usePostNotificationAPIWithOutTokenMutation,
  useGetNotificationAPIQuery,
  usePostNotificationAPIWithTokenMutation,
} from '../Api/api';
import Avatar from '@mui/material/Avatar';
import orderThatIcon from '../Images/orderThatIcon.png';
import OrderThatLogoAnimationRed from '../Images/orderThatLogoAnimationRed.svg';
import NotificationIcon from '../Images/ic-notification-black.png';
import {
  READ_ALL_NOTIFICATION,
  UPDATE_NOTIFICATION,
  READ_ONE_USER,
  READ_ALL_ORDERS,
  READ_NESTED_CATEGORIES,
} from '../Api/apiConstant';
import { toast, ToastContainer } from 'react-toastify';
import { skipToken } from '@reduxjs/toolkit/query/react';
import { getUserLogin, removeAllCookies, removeUserLogin } from '../LoginModule/LoginUtility';
import { setNotificationTotalCount } from '../Features/message/messageSlice';

const Search = styled('div')(({ theme }) => ({
  position: 'relative',
  borderRadius: '20px',
  backgroundColor: WHITE,
  border: `0.6px solid ${SEARCH_BORDER}`,
  marginRight: theme.spacing(2),
  marginLeft: theme.spacing(3),
  width: 'auto',
  '&:hover': {
    backgroundColor: alpha(SEARCH_BACKGROUND, 0.25),
  },
}));
const SearchIconWrapper = styled('div')({
  height: '100%',
  position: 'absolute',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  pointerEvents: 'none',
  zIndex: 2,
  paddingLeft: '0px',
  marginLeft: '10px',
});
const StyledInputBase = styled(InputBase)(({ theme }) => ({
  color: SEARCH_COLOR,
  fontSize: '16px !important',
  fontFamily: 'Poppins, sans-serif !important',
  '& .MuiInputBase-input': {
    padding: theme.spacing(1, 1, 1, 0),
    paddingLeft: `calc(1em + ${theme.spacing(4)})`,
    width: '35ch',
    fontFamily: 'Poppins, sans-serif !important',
    fontSize: '16px !important',
  },
  '& .MuiInputBase-input::placeholder': {
    color: 'black !important',
    opacity: '1 !important',
    fontSize: '16px !important',
    fontFamily: 'Poppins, sans-serif !important',
  },
  '& input::placeholder': {
    color: 'black !important',
    opacity: '1 !important',
    fontSize: '16px !important',
    fontFamily: 'Poppins, sans-serif !important',
  },
}));
const Listbox = styled('ul')(({ theme }) => ({
  width: 410,
  margin: 0,
  padding: 0,
  position: 'absolute',
  listStyle: 'none',
  borderRadius: '10px',
  maxHeight: 200,
  overflow: 'auto',
  zIndex: 1,
  backgroundColor: '#fff',
  border: '1px solid rgba(0,0,0,.25)',
  '& li': {
    padding: theme.spacing(1),
    display: 'flex',
    alignItems: 'center',
    cursor: 'pointer',
    fontSize: '16px',
  },
  '& li.Mui-focused, & li.selected, & li:hover': {
    backgroundColor: '#ED1C25',
    color: 'white',
  },
}));
const isSvg = (url) => {
  if (!url) return false;
  if (typeof url === 'string') {
    return (
      url.split('?')[0].split('#')[0].toLowerCase().endsWith('.svg') ||
      url.startsWith('data:image/svg+xml')
    );
  }
  if (url instanceof File) {
    return url.type === 'image/svg+xml' || url.name.toLowerCase().endsWith('.svg');
  }
  return false;
};

const isActiveOrder = (order) => {
  const rawStatus =
    order.order_status || order.status || order.orderStatusDetails?.order_status || '';
  const status = rawStatus ? String(rawStatus).trim().toLowerCase() : '';

  const now = new Date();
  let eventHasEnded = false;
  if (order.event_end_date) {
    const eventEnd = new Date(order.event_end_date);
    if (!isNaN(eventEnd.getTime())) {
      eventEnd.setHours(23, 59, 59, 999);
      eventHasEnded = eventEnd < now;
    }
  }

  if (status === 'delivered' || status === 'cancel' || status === 'cancelled') {
    // If event has ended, move out of active orders. Otherwise, keep active until event is over!
    if (eventHasEnded) {
      return false;
    }
    return true;
  }

  if (order.event_end_date) {
    return !eventHasEnded;
  }

  return true;
};

function Navbar({ className, eventName, isAtAllEvents: propIsAtAllEvents }) {
  const isInLayout = useContext(LayoutContext);
  const navigate = useNavigate();
  const location = useLocation();

  const isAtAllEvents =
    propIsAtAllEvents !== undefined
      ? propIsAtAllEvents
      : (() => {
          const segments = location.pathname.split('/').filter(Boolean);
          const eventsIndex = segments.indexOf('events');
          if (eventsIndex === -1) return false;
          const nextSegment = segments[eventsIndex + 1];
          return (
            !nextSegment ||
            ['contact', 'terms-and-conditions', 'privacy-policy'].includes(nextSegment)
          );
        })();

  const [anchorEl, setAnchorEl] = useState(null);
  const [anchorElGetStarted, setAnchorElGetStarted] = useState(null);
  const [showMenu, setShowMenu] = useState(false);
  const [activeItem, setActiveItem] = useState('');
  const isLoggedIn = useSelector((state) => state.auth.isAuthenticated);
  const loggedIn = isLoggedIn;
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const [anchorElPop, setAnchorElPop] = React.useState(null);
  const [anchorElToggle, setAnchorElToggle] = useState(null);
  const [selectedIndex, setSelectedIndex] = useState(-1);
  const cartId = useSelector((state) => state?.cart?.cartId);
  const seachParms = new URLSearchParams(location.search);
  const seachQuery = seachParms.get('search');
  const [searchInput, setSearchInput] = React.useState(seachQuery || '');
  const userId = useSelector((state) => state.auth.user?.user_id);
  const eventId = useSelector((state) => state.currentEvent.eventId);
  const preorderStartDateStr = useSelector((state) => state.currentEvent.preorderStartDate);
  const preorderEndDateStr = useSelector((state) => state.currentEvent.preorderEndDate);
  const dispatch = useDispatch();
  const [isListboxOpen, setIsListboxOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const [updateIsReadNotification] = usePostNotificationAPIWithTokenMutation();
  const shouldCallnotifcationAPI = userId != null && eventId != null;
  const shouldCallproductAPI = eventId != null;
  const shouldCallUserAPI = userId != null && eventId != null;
  const [isBackspacePressed, setIsBackspacePressed] = useState(false);
  const [openDialog, setOpenDialog] = useState(false);

  const { data: notifcation, isLoading } = useGetNotificationAPIQuery(
    isLoggedIn
      ? {
          url: `${READ_ALL_NOTIFICATION}?user_id=${userId}&event_id=${eventId || 0}`,
        }
      : skipToken,
    { refetchOnMountOrArgChange: true }
  );

  const { data: ordersData } = useGetAPIQuery(
    isLoggedIn && userId && userId !== 'null' && userId !== 'undefined'
      ? {
          url: `${READ_ALL_ORDERS}user_id=${userId}`,
        }
      : skipToken,
    { refetchOnMountOrArgChange: true }
  );

  const activeOrdersCount = useMemo(() => {
    if (!ordersData?.data || !Array.isArray(ordersData.data)) return 0;
    return ordersData.data.filter(isActiveOrder).length;
  }, [ordersData]);

  const notificationCount = useSelector((state) => state.message.count);

  useEffect(() => {}, [notificationCount]);

  useEffect(() => {
    if (!isLoading && notifcation && notifcation.data) {
      const unreadCount = notifcation.data.filter((notification) => !notification.is_read).length;
      dispatch(setNotificationTotalCount(unreadCount));
    }
  }, [isLoading, notifcation, dispatch]);

  useEffect(() => {
    if (!seachQuery) {
      setSearchInput('');
    }
  }, [seachQuery]);

  const handleSearchInputChange = useCallback((event) => {
    setSearchInput(event.target.value);
  }, []);

  const handleClearSearch = useCallback(() => {
    setSearchInput('');

    const url = new URL(window.location);
    url.searchParams.delete('search');
    window.history.pushState({}, '', url);
  }, []);

  useEffect(() => {
    if (location.state?.productName) {
      setSearchInput(location.state.productName);
    }
  }, [location]);
  const [debouncedSearch, setDebouncedSearch] = useState(searchInput);

  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedSearch(searchInput);
    }, 500);

    return () => clearTimeout(timer);
  }, [searchInput]);

  const currentEventName = useSelector((state) => state.currentEvent.eventName);
  const eventNameData = eventName ? eventName : currentEventName;

  const {
    data,
    isLoading: productLoadinfg,
    isError: productError,
    error,
  } = useGetAPIWithoutTokenQuery(
    shouldCallproductAPI
      ? `/product/readAllProducts?event_id=${eventId}&page=${1}&limit=${500}&search=${debouncedSearch}`
      : skipToken
  );

  const filteredOptions = data?.data?.filter(
    (option) =>
      option?.product_name?.toLowerCase()?.includes(searchInput?.toLowerCase()) ||
      option?.brands?.[0]?.brand_name?.toLowerCase()?.includes(searchInput?.toLowerCase()) ||
      option?.categories?.[0]?.category_name?.toLowerCase()?.includes(searchInput?.toLowerCase()) ||
      option?.product_description?.toLowerCase()?.includes(searchInput?.toLowerCase())
  );

  const handleOptionClick = useCallback(
    (option, type = 'enter') => {
      if (option !== undefined) {
        setSearchInput(option.product_name);
        setIsListboxOpen(false);
        navigate(`/events/${eventNameData || eventId}/shop?search=${searchInput}`, {
          state: {
            results: type == 'enter' ? filteredOptions : [option],
            category: 'searchResults',
          },
        });
      }
    },
    [navigate, eventId, searchInput, filteredOptions, eventNameData]
  );

  const {
    getRootProps,
    getInputProps,
    getListboxProps,
    getOptionProps,
    groupedOptions,
    setValue,
    inputValue,
  } = useAutocomplete({
    id: 'use-autocomplete-demo',
    options: filteredOptions || [],
    getOptionLabel: (option) =>
      option?.product_name ||
      option?.brands?.[0]?.brand_name ||
      option?.categories?.[0]?.category_name ||
      option?.product_description ||
      '',
    filterOptions: (options, { inputValue }) =>
      options.filter(
        (option) =>
          option?.product_name?.toLowerCase()?.includes(inputValue?.toLowerCase()) ||
          option?.brands?.[0]?.brand_name?.toLowerCase()?.includes(searchInput?.toLowerCase()) ||
          option?.categories?.[0]?.category_name
            ?.toLowerCase()
            ?.includes(searchInput?.toLowerCase()) ||
          option?.product_description?.toLowerCase()?.includes(searchInput?.toLowerCase())
      ),
  });

  const handleSearch = useCallback(
    (searchValue) => {
      const matchingOption = groupedOptions.find(
        (option) =>
          option?.product_name?.toLowerCase() === searchValue?.toLowerCase() ||
          option?.brands?.[0]?.brand_name?.toLowerCase()?.includes(searchInput?.toLowerCase()) ||
          option?.categories?.[0]?.category_name
            ?.toLowerCase()
            ?.includes(searchInput?.toLowerCase()) ||
          option?.product_description?.toLowerCase()?.includes(searchInput?.toLowerCase())
      );

      if (matchingOption) {
        handleOptionClick(matchingOption);
      }
    },
    [groupedOptions, searchInput, handleOptionClick]
  );

  const {
    primaryColor,
    secondaryColor,
    textColor,
    buttonColor,
    linkColor,
    backgroundColor,
    logo,
    fontFamily: themeFontFamily,
    fontWeight,
    fontSize,
  } = useThemeColors();
  const fontFamily = 'Poppins, sans-serif';

  const {
    data: userData,
    isSuccess: userSuccess,
    refetch: refetchUser,
  } = useGetAPIQuery(
    {
      url: `${READ_ONE_USER}user_id=${userId}`,
    },
    { skip: !userId || userId === 'null' || userId === 'undefined' }
  );

  // Listen for profile updates from Profile page — refetch user data instantly
  useEffect(() => {
    const handleProfileUpdate = () => {
      if (userId && userId !== 'null' && userId !== 'undefined') {
        refetchUser();
      }
    };
    window.addEventListener('userProfileUpdated', handleProfileUpdate);
    return () => window.removeEventListener('userProfileUpdated', handleProfileUpdate);
  }, [userId, refetchUser]);

  const userLogin = useSelector((state) => state.auth.userLogin);

  useEffect(() => {
    if (!userData || !userData.data) return;

    if (userLogin !== 'true') return;

    const actualUser = userData.data;
    const missingFields = [];
    if (!actualUser.user_name) missingFields.push('Name');
    if (!actualUser.user_email) missingFields.push('Email');
    if (!actualUser.phone_number) missingFields.push('Phone Number');
    if (!actualUser.zip_code) missingFields.push('Zip Code');

    if (missingFields.length > 0) {
      const formattedFields =
        missingFields.length === 1
          ? missingFields[0]
          : `${missingFields.slice(0, -1).join(', ')} and ${missingFields.slice(-1)}`;

      toast.error(
        `Your ${formattedFields} ${missingFields.length > 1 ? 'are' : 'is'} not filled. Please fill ${
          missingFields.length > 1 ? 'them' : 'it'
        } in your profile for better experience.`,
        { autoClose: 1000 },
        { containerId: 'child' }
      );
      dispatch(clearUserLoginHint());
    }
  }, [userData, userLogin, dispatch]);

  function getInitials(firstName, lastName) {
    if (firstName && lastName) {
      const initials = firstName.charAt(0).toUpperCase() + lastName.charAt(0).toUpperCase();
      return initials;
    } else if (firstName) {
      return firstName.charAt(0).toUpperCase();
    } else if (lastName) {
      return lastName.charAt(0).toUpperCase();
    }
    return '';
  }

  const activePage = useMemo(() => {
    if (location.pathname.includes('/shop') || location.pathname.includes('/product-detail'))
      return 'shop';
    if (location.pathname.includes('/cart')) return 'cart';
    if (location.pathname.includes('/contact')) return 'contact';
    if (location.pathname.includes('/profile')) return 'profile';
    if (location.pathname.includes('/notification')) return 'notification';
    if (location.pathname.includes('/active-orders')) return 'active-orders';
    if (location.pathname.includes('/purchase-history')) return 'purchase-history';
    if (location.pathname === '/') return '/';

    // Only return 'home' if we are actually on the home page (/events or /events/:id)
    const segments = location.pathname.split('/').filter(Boolean);
    if (segments.length === 1 && segments[0] === 'events') return 'home';
    if (segments.length === 2 && segments[0] === 'events') return 'home';

    return '';
  }, [location.pathname]);

  const activeIdx = useMemo(() => {
    if (location.pathname.includes('/cart') || location.pathname.includes('/confirm-order')) {
      return 0;
    }
    if (location.pathname.includes('/notification')) {
      return 1;
    }
    if (
      location.pathname.includes('/profile') ||
      location.pathname.includes('/orders') ||
      location.pathname.includes('/active-orders') ||
      location.pathname.includes('/purchase-history') ||
      location.pathname.includes('/myEvents')
    ) {
      return 2;
    }
    return -1;
  }, [location.pathname]);

  const [isShopDropdownOpen, setIsShopDropdownOpen] = useState(false);
  const { data: categoriesData } = useGetAPIWithoutTokenQuery(
    eventId ? `${READ_NESTED_CATEGORIES}?event_id=${eventId}&hide_empty=true` : skipToken
  );

  const handleMobileCategoryClick = useCallback(
    (categoryId, categoryName) => {
      navigate(`/events/${eventNameData || eventId}/shop`, {
        state: {
          category: categoryId,
          categoryName: categoryName,
        },
      });
      setShowMenu(false);
    },
    [navigate, eventId, eventNameData]
  );

  const handleBrowseAllClick = useCallback(() => {
    navigate(`/events/${eventNameData || eventId}/shop`, {
      state: {
        category: 'all',
        categoryName: 'All Products',
      },
    });
    setShowMenu(false);
  }, [navigate, eventId, eventNameData]);

  const listboxProps = getListboxProps();
  const handleClick = useCallback(
    (event) => {
      if (!eventId) {
        navigate(`/events/`);
      } else {
        navigate(`/events/${eventNameData || eventId}/cart`);
      }
    },
    [navigate, eventId, eventNameData]
  );

  const open = Boolean(anchorElPop);
  const id = open ? 'simple-popover' : undefined;

  const timeoutRef = useRef(null);

  const handleCloseMenu = useCallback(() => {
    if (timeoutRef.current) clearTimeout(timeoutRef.current);
    timeoutRef.current = setTimeout(() => {
      setAnchorEl(null);
    }, 300);
  }, []);

  const cartItems = useSelector((state) => state?.cart?.items);
  const bundle = useSelector((state) => state?.cart?.bundle);
  const totalQuantity = useSelector((state) => state?.cart?.totalQuantity);
  const guestTotalQuantity = useSelector((state) => state?.guestCart?.totalQuantity);

  const cartBadgeValue = useMemo(() => {
    return isLoggedIn ? totalQuantity || 0 : guestTotalQuantity || 0;
  }, [isLoggedIn, totalQuantity, guestTotalQuantity]);

  const handleHome = useCallback(() => {
    if (isAtAllEvents || !eventId) {
      navigate(`/events/`);
    } else {
      navigate(`/events/${eventNameData || eventId}`);
    }
  }, [navigate, eventId, eventNameData, isAtAllEvents]);

  const handleShop = useCallback(() => {
    if (!eventId) {
      navigate(`/events/`);
    } else {
      navigate(`/events/${eventNameData || eventId}/shop`, { state: { category: 'all' } });
    }
  }, [navigate, eventId, eventNameData]);

  const handleAllEvents = useCallback(() => {
    if (location.pathname === '/events') {
      window.scrollTo(0, 0);
    } else {
      navigate(`/events/`);
    }
  }, [location.pathname, navigate]);

  const handleAbout = useCallback(() => {
    if (isAtAllEvents || !eventId) {
      navigate(`/events/contact`, { state: { isAtAllEvents: isAtAllEvents || !eventId } });
    } else {
      navigate(`/events/${eventNameData || eventId}/contact`);
    }
  }, [isAtAllEvents, navigate, eventId, eventNameData]);

  const handleOpenMenu = useCallback((event) => {
    if (timeoutRef.current) clearTimeout(timeoutRef.current);
    setAnchorEl(event.currentTarget);
  }, []);

  const handleMenuMouseEnter = useCallback(() => {
    if (timeoutRef.current) clearTimeout(timeoutRef.current);
  }, []);

  const handleResize = useCallback(() => {
    const newWidth = window.innerWidth;
    setWindowWidth((prevWidth) => {
      // Only close the mobile drawer when switching from mobile to desktop view
      // (crossing 1260px upward). Avoid closing on minor resize events caused
      // by MUI's scroll-lock padding adjustment.
      if (prevWidth < 1260 && newWidth >= 1260) {
        setShowMenu(false);
      }
      return newWidth;
    });
  }, []);

  const handleUpdateNotification = useCallback(
    async (notificationIds) => {
      // Create payload as JSON
      const payload = Array.isArray(notificationIds)
        ? { notification_id: notificationIds, is_read: true }
        : { notification_id: notificationIds, is_read: true };

      try {
        const response = await updateIsReadNotification({
          url: UPDATE_NOTIFICATION,
          formData: payload,
        });

        // Update the notification count in the Redux store
        const unreadCount = notifcation.data.filter((notification) => !notification.is_read).length;
        dispatch(setNotificationTotalCount(unreadCount));
      } catch (error) {}
    },
    [updateIsReadNotification, notifcation, dispatch]
  );

  useEffect(() => {
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, [handleResize]);

  useEffect(() => {
    window.addEventListener('scroll', () => {
      setAnchorEl(null);
    });
  }, []);

  const handleMenuClick = useCallback(
    (event) => {
      setShowMenu(!showMenu);
      setAnchorElToggle(!showMenu);
    },
    [showMenu]
  );

  const handleNavigation = useCallback(
    (route) => {
      navigate(route);
    },
    [navigate]
  );

  const handleSignOut = useCallback(() => {
    setOpenDialog(true);
  }, []);

  const handleLogout = useCallback(() => {
    dispatch(logoutUser());
    dispatch(logout());
    dispatch(clearCart());
    removeAllCookies();
    if (!eventId) {
      navigate(`/events/`);
    } else {
      navigate(`/events/${eventNameData || eventId}`);
    }
    window.location.reload();
  }, [dispatch, navigate, eventId, eventNameData]);

  const handleCloseToggle = useCallback(() => {
    setAnchorElToggle(null);
    setShowMenu(false);
  }, []);

  const handleLogin = useCallback(() => {
    if (!eventId) {
      navigate(`/events/`);
    } else {
      navigate(`/events/${eventNameData || eventId}/login`);
    }
  }, [navigate, eventId, eventNameData]);

  const handleRegister = useCallback(() => {
    if (!eventId) {
      navigate(`/events/`);
    } else {
      navigate(`/events/${eventNameData || eventId}/register`);
    }
  }, [navigate, eventId, eventNameData]);

  const getStartedTimeoutRef = useRef(null);

  const handleOpenGetStarted = useCallback((event) => {
    if (getStartedTimeoutRef.current) clearTimeout(getStartedTimeoutRef.current);
    setAnchorElGetStarted(event.currentTarget);
  }, []);

  const handleCloseGetStarted = useCallback(() => {
    if (getStartedTimeoutRef.current) clearTimeout(getStartedTimeoutRef.current);
    getStartedTimeoutRef.current = setTimeout(() => {
      setAnchorElGetStarted(null);
    }, 300);
  }, []);

  const handleGetStartedMenuMouseEnter = useCallback(() => {
    if (getStartedTimeoutRef.current) clearTimeout(getStartedTimeoutRef.current);
  }, []);

  const handleProfile = useCallback(() => {
    if (!eventId) {
      navigate(`/events/`);
    } else {
      navigate(`/events/${eventNameData || eventId}/profile`);
    }
  }, [navigate, eventId, eventNameData]);

  const handleActiveOrders = useCallback(() => {
    if (!eventId) {
      navigate(`/events/`);
    } else {
      navigate(`/events/${eventNameData || eventId}/active-orders/0`);
    }
  }, [navigate, eventId, eventNameData]);

  const handlePurchaseHistory = useCallback(() => {
    if (!eventId) {
      navigate(`/events/`);
    } else {
      navigate(`/events/${eventNameData || eventId}/purchase-history/0`);
    }
  }, [navigate, eventId, eventNameData]);

  const handleCart = useCallback(() => {
    if (!eventId) {
      navigate(`/events/`);
      return;
    }
    {
      const currentDate = new Date();
      const preorderStartDate = new Date(preorderStartDateStr);
      const preorderEndDate = preorderEndDateStr
        ? typeof preorderEndDateStr === 'string' && preorderEndDateStr.includes('T')
          ? new Date(preorderEndDateStr)
          : new Date(new Date(preorderEndDateStr).getTime() + 86399999)
        : null;
      if (currentDate < preorderStartDate) {
        toast.error('Pre-order has not started yet.');
        return;
      } else if (currentDate > preorderEndDate) {
        toast.error("The pre-order period has expired. You can't place an order.");
        return;
      }
    }
    navigate(`/events/${eventNameData || eventId}/cart`);
  }, [navigate, eventId, eventNameData, preorderStartDateStr, preorderEndDateStr]);

  const handleNotification = useCallback(() => {
    if (!eventId) {
      navigate(`/events/`);
    } else {
      navigate(`/events/${eventNameData || eventId}/notification`);
    }
  }, [navigate, eventId, eventNameData]);

  const handleInputChange = useCallback(
    (e) => {
      setSearchInput(e.target.value.trimStart());
      setIsListboxOpen(e.target.value.length > 0);
      if (e.target.value.length <= 0 && location.pathname.includes('/shop')) {
        if (!eventId) {
          navigate(`/events/`);
        } else {
          navigate(`/events/${eventNameData || eventId}/shop`, { state: { category: 'all' } });
        }
      }
    },
    [location.pathname, navigate, eventId, eventNameData]
  );

  const handleKeyDown = useCallback(
    (e) => {
      if (e.key === 'ArrowDown') {
        setSelectedIndex((prevIndex) => Math.min(prevIndex + 1, groupedOptions.length - 1));
        setIsListboxOpen(true);
      } else if (e.key === 'ArrowUp') {
        setSelectedIndex((prevIndex) => Math.max(prevIndex - 1, 0));
        setIsListboxOpen(true);
      } else if (e.key === 'Enter' && searchInput.length >= 3) {
        handleOptionClick({ product_name: searchInput }, 'enter');
      }
    },
    [groupedOptions.length, searchInput, handleOptionClick]
  );

  const handleEnterKeyPress = useCallback(() => {
    if (groupedOptions.length > 0 && selectedIndex >= 0) {
      const selectedOption = groupedOptions[selectedIndex];
      handleOptionClick(selectedOption);
    } else if (searchInput.trim() !== '') {
      const matchingOption = filteredOptions.find(
        (option) =>
          option?.product_name?.toLowerCase() === searchInput?.toLowerCase() ||
          option?.brands?.[0]?.brand_name?.toLowerCase() === searchInput?.toLowerCase() ||
          option?.categories?.[0]?.category_name?.toLowerCase() === searchInput?.toLowerCase() ||
          option?.product_description?.toLowerCase() === searchInput?.toLowerCase()
      );

      if (matchingOption) {
        handleOptionClick(matchingOption);
      } else {
        setIsListboxOpen(true);
      }
    } else {
      setIsListboxOpen(true);
    }
  }, [groupedOptions, selectedIndex, searchInput, filteredOptions, handleOptionClick]);

  // Guard: if this Navbar is rendered inside a page that is already inside the UserLayout,
  // suppress it — only the root-level UserLayout instance should render.
  if (isInLayout) {
    return null;
  }

  return (
    <>
      <ToastContainer containerId="child" />
      <nav
        className={className}
        style={{
          padding: windowWidth <= 900 ? '0 10px' : '0 30px',
          boxShadow: '0 4px 12px rgba(0, 0, 0, 0.05)',
          position: windowWidth <= 900 ? 'sticky' : 'fixed',
          top: 0,
          zIndex: 1000,
          backgroundColor: '#ffffff',
          width: '100%',
        }}
      >
        <div className="nav-style d-flex justify-content-between align-items-center py-3">
          <div
            style={{
              cursor: 'pointer',
              width: '100%',
              maxWidth: windowWidth <= 900 ? '50px' : '100px',
              height: 'auto',
              maxHeight: windowWidth <= 900 ? '50px' : '100px',
              display: 'flex',
              alignItems: 'center',
            }}
            onClick={() =>
              handleNavigation(isAtAllEvents || !eventId ? `/events/` : `/events/${eventNameData}`)
            }
          >
            {isSvg(logo || OrderThatLogoAnimationRed) ? (
              <object
                data={logo || OrderThatLogoAnimationRed}
                type="image/svg+xml"
                style={{
                  width: '100%',
                  height: '100%',
                  pointerEvents: 'none',
                }}
              >
                <img
                  src={logo || OrderThatLogoAnimationRed}
                  alt="Logo"
                  style={{
                    width: '100%',
                    height: '100%',
                    objectFit: 'contain',
                  }}
                />
              </object>
            ) : (
              <img
                src={logo || OrderThatLogoAnimationRed}
                alt="Logo"
                style={{
                  width: '100%',
                  height: '100%',
                  objectFit: 'contain',
                }}
              />
            )}
          </div>
          <div
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              height: '100%',
            }}
          >
            {!isAtAllEvents && (
              <Search
                style={{
                  flexGrow: 1,
                  marginLeft: windowWidth <= 900 ? '10px' : undefined,
                  marginRight: windowWidth <= 900 ? '10px' : undefined,
                }}
              >
                <SearchIconWrapper>
                  <SearchIcon />
                </SearchIconWrapper>
                {(() => {
                  const { ref, ...otherInputProps } = getInputProps();
                  return (
                    <StyledInputBase
                      inputRef={ref}
                      {...otherInputProps}
                      value={searchInput}
                      placeholder="Search products"
                      onKeyDown={handleKeyDown}
                      onChange={handleInputChange}
                      onFocus={() => setIsListboxOpen(true)}
                      onBlur={() => setTimeout(() => setIsListboxOpen(false), 150)}
                      style={{
                        fontFamily: 'Poppins, sans-serif',
                        fontSize: '16px',
                        fontWeight: 400,
                        width: '100%',
                      }}
                      sx={{
                        '& .MuiInputBase-input': {
                          width: windowWidth <= 900 ? '100% !important' : '35ch',
                          paddingLeft: windowWidth <= 900 ? '40px !important' : undefined,
                          fontSize: '16px !important',
                          fontFamily: 'Poppins, sans-serif !important',
                        },
                        '& .MuiInputBase-input::placeholder': {
                          fontSize: '16px !important',
                          fontFamily: 'Poppins, sans-serif !important',
                        },
                      }}
                    />
                  );
                })()}
                {isListboxOpen && searchInput && (
                  <Listbox {...getListboxProps()}>
                    {filteredOptions?.filter(
                      (product) => !product?.skus?.every((sku) => sku?.sku_status === 0)
                    )?.length > 0 ? (
                      filteredOptions
                        ?.filter((product) => !product?.skus?.every((sku) => sku?.sku_status === 0))
                        ?.map((option, index) => (
                          <li
                            {...getOptionProps({
                              option,
                              index: option.product_id,
                            })}
                            key={option.product_id}
                            onClick={() => handleOptionClick(option, 'onclick')}
                            className={selectedIndex === index ? 'selected' : ''}
                            style={{ fontFamily, fontSize: '16px', fontWeight }}
                          >
                            <span>{option.product_name}</span>
                          </li>
                        ))
                    ) : (
                      <li style={{ fontFamily, fontSize: '16px', fontWeight }}>No results found</li>
                    )}
                  </Listbox>
                )}
              </Search>
            )}

            {windowWidth < 1260 ? (
              <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                {!isAtAllEvents && (
                  <div
                    style={{
                      position: 'relative',
                      width: '40px',
                      height: '40px',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      cursor: 'pointer',
                    }}
                    onClick={handleCart}
                  >
                    <ShoppingCartOutlinedIcon
                      style={{
                        cursor: 'pointer',
                        color: 'black',
                        fontSize: '28px',
                        flexShrink: 0,
                      }}
                    />
                    {cartBadgeValue > 0 && (
                      <span
                        style={{
                          position: 'absolute',
                          top: '0px',
                          right: '0px',
                          backgroundColor: primaryColor || PRIMARY,
                          height: '18px',
                          minWidth: '18px',
                          padding: '0 4px',
                          borderRadius: '9px',
                          fontSize: '10px',
                          fontWeight: fontWeight || 'bold',
                          color: 'white',
                          zIndex: 100,
                          display: 'flex',
                          justifyContent: 'center',
                          alignItems: 'center',
                          fontFamily,
                        }}
                      >
                        {cartBadgeValue}
                      </span>
                    )}
                  </div>
                )}
                <IconButton onClick={() => setShowMenu(true)} style={{ padding: '8px' }}>
                  <MenuIcon />
                </IconButton>
                <Drawer
                  anchor="right"
                  open={showMenu}
                  onClose={() => setShowMenu(false)}
                  disableScrollLock={false}
                  PaperProps={{
                    className: 'mobile-drawer-paper',
                  }}
                >
                  {/* Header */}
                  <div
                    style={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      alignItems: 'center',
                      padding: '10px 20px',
                      borderBottom: '1px solid #eaeaea',
                      height: '80px',
                    }}
                  >
                    {/* Left: Logo */}
                    <div
                      style={{
                        cursor: 'pointer',
                        width: '100%',
                        maxWidth: '50px',
                        height: 'auto',
                        maxHeight: '50px',
                        display: 'flex',
                        alignItems: 'center',
                      }}
                      onClick={() => {
                        handleHome();
                        setShowMenu(false);
                      }}
                    >
                      {isSvg(logo || OrderThatLogoAnimationRed) ? (
                        <object
                          data={logo || OrderThatLogoAnimationRed}
                          type="image/svg+xml"
                          style={{
                            width: '100%',
                            height: '100%',
                            pointerEvents: 'none',
                          }}
                        >
                          <img
                            src={logo || OrderThatLogoAnimationRed}
                            alt="Logo"
                            style={{
                              width: '100%',
                              height: '100%',
                              objectFit: 'contain',
                            }}
                          />
                        </object>
                      ) : (
                        <img
                          src={logo || OrderThatLogoAnimationRed}
                          alt="Logo"
                          style={{
                            width: '100%',
                            height: '100%',
                            objectFit: 'contain',
                          }}
                        />
                      )}
                    </div>

                    {/* Right: Cart & Close */}
                    <div
                      style={{
                        marginLeft: 'auto',
                        display: 'flex',
                        alignItems: 'center',
                        gap: '15px',
                      }}
                    >
                      {!isAtAllEvents && (
                        <div
                          style={{
                            position: 'relative',
                            width: '40px',
                            height: '40px',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            cursor: 'pointer',
                          }}
                          onClick={() => {
                            handleCart();
                            setShowMenu(false);
                          }}
                        >
                          <ShoppingCartOutlinedIcon
                            style={{
                              cursor: 'pointer',
                              color: 'black',
                              fontSize: '28px',
                              flexShrink: 0,
                            }}
                          />
                          {cartBadgeValue > 0 && (
                            <span
                              style={{
                                position: 'absolute',
                                top: '0px',
                                right: '0px',
                                backgroundColor: primaryColor || PRIMARY,
                                height: '18px',
                                minWidth: '18px',
                                padding: '0 4px',
                                borderRadius: '9px',
                                fontSize: '10px',
                                fontWeight: fontWeight || 'bold',
                                color: 'white',
                                zIndex: 100,
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                                fontFamily,
                              }}
                            >
                              {cartBadgeValue}
                            </span>
                          )}
                        </div>
                      )}
                      <IconButton onClick={() => setShowMenu(false)} style={{ color: 'black' }}>
                        <CloseIcon style={{ fontSize: '28px' }} />
                      </IconButton>
                    </div>
                  </div>

                  {/* Body Links */}
                  <div
                    style={{
                      flexGrow: 1,
                      padding: '20px 24px',
                      display: 'flex',
                      flexDirection: 'column',
                      gap: '12px',
                      overflowY: 'auto',
                    }}
                  >
                    <div
                      onClick={() => {
                        handleHome();
                        setShowMenu(false);
                      }}
                      style={{
                        fontSize: '20px',
                        fontWeight: activePage === 'home' ? '700' : '500',
                        fontFamily,
                        cursor: 'pointer',
                        color: activePage === 'home' ? primaryColor || '#ED1C25' : 'black',
                      }}
                    >
                      Home
                    </div>

                    {!isAtAllEvents && (
                      <>
                        <div
                          onClick={() => {
                            setIsShopDropdownOpen((prev) => !prev);
                          }}
                          style={{
                            fontSize: '20px',
                            fontWeight: activePage === 'shop' ? '700' : '500',
                            fontFamily,
                            cursor: 'pointer',
                            color: activePage === 'shop' ? primaryColor || '#ED1C25' : 'black',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'space-between',
                          }}
                        >
                          <span>Shop</span>
                          {isShopDropdownOpen ? (
                            <ExpandMoreIcon style={{ color: '#888' }} />
                          ) : (
                            <ChevronRightIcon style={{ color: '#888' }} />
                          )}
                        </div>

                        {isShopDropdownOpen && (
                          <div
                            style={{
                              paddingLeft: '15px',
                              display: 'flex',
                              flexDirection: 'column',
                              gap: '10px',
                              marginTop: '5px',
                            }}
                          >
                            <div
                              onClick={handleBrowseAllClick}
                              style={{
                                fontSize: '16px',
                                fontFamily,
                                color: '#555',
                                cursor: 'pointer',
                                padding: '6px 0',
                              }}
                            >
                              Browse All
                            </div>

                            {categoriesData?.data?.map((category) => (
                              <div key={category.category_id}>
                                <div
                                  onClick={() =>
                                    handleMobileCategoryClick(
                                      category.category_id,
                                      category.category_name
                                    )
                                  }
                                  style={{
                                    fontSize: '16px',
                                    fontFamily,
                                    color: '#555',
                                    cursor: 'pointer',
                                    padding: '6px 0',
                                    fontWeight: '500',
                                  }}
                                >
                                  {category.category_name}
                                </div>
                                {category.children && category.children.length > 0 && (
                                  <div
                                    style={{
                                      paddingLeft: '15px',
                                      display: 'flex',
                                      flexDirection: 'column',
                                      gap: '6px',
                                    }}
                                  >
                                    {category.children.map((subcat) => (
                                      <div
                                        key={subcat.category_id}
                                        onClick={() =>
                                          handleMobileCategoryClick(
                                            subcat.category_id,
                                            subcat.category_name
                                          )
                                        }
                                        style={{
                                          fontSize: '14px',
                                          fontFamily,
                                          color: '#777',
                                          cursor: 'pointer',
                                          padding: '4px 0',
                                        }}
                                      >
                                        {subcat.category_name}
                                      </div>
                                    ))}
                                  </div>
                                )}
                              </div>
                            ))}
                          </div>
                        )}
                      </>
                    )}

                    {!isAtAllEvents && (
                      <div
                        onClick={() => {
                          handleCart();
                          setShowMenu(false);
                        }}
                        style={{
                          fontSize: '20px',
                          fontWeight: activePage === 'cart' ? '700' : '500',
                          fontFamily,
                          cursor: 'pointer',
                          color: activePage === 'cart' ? primaryColor || '#ED1C25' : 'black',
                          display: 'flex',
                          alignItems: 'center',
                          gap: '8px',
                        }}
                      >
                        <span>Cart</span>
                        {cartBadgeValue > 0 && (
                          <span
                            style={{
                              backgroundColor: primaryColor || '#ED1C25',
                              color: 'white',
                              fontSize: '11px',
                              fontWeight: '700',
                              borderRadius: '10px',
                              padding: '2px 6px',
                              display: 'inline-flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              minWidth: '20px',
                              height: '20px',
                              fontFamily,
                            }}
                          >
                            {cartBadgeValue}
                          </span>
                        )}
                      </div>
                    )}

                    {loggedIn && (
                      <>
                        <div
                          onClick={() => {
                            handleProfile();
                            setShowMenu(false);
                          }}
                          style={{
                            fontSize: '20px',
                            fontWeight: activePage === 'profile' ? '700' : '500',
                            fontFamily,
                            cursor: 'pointer',
                            color: activePage === 'profile' ? primaryColor || '#ED1C25' : 'black',
                          }}
                        >
                          Personal Info
                        </div>

                        <div
                          onClick={() => {
                            handleActiveOrders();
                            setShowMenu(false);
                          }}
                          style={{
                            fontSize: '20px',
                            fontWeight: activePage === 'active-orders' ? '700' : '500',
                            fontFamily,
                            cursor: 'pointer',
                            color:
                              activePage === 'active-orders' ? primaryColor || '#ED1C25' : 'black',
                          }}
                        >
                          Active Orders
                        </div>

                        <div
                          onClick={() => {
                            handlePurchaseHistory();
                            setShowMenu(false);
                          }}
                          style={{
                            fontSize: '20px',
                            fontWeight: activePage === 'purchase-history' ? '700' : '500',
                            fontFamily,
                            cursor: 'pointer',
                            color:
                              activePage === 'purchase-history'
                                ? primaryColor || '#ED1C25'
                                : 'black',
                          }}
                        >
                          Purchase History
                        </div>

                        <div
                          onClick={() => {
                            handleNotification();
                            setShowMenu(false);
                          }}
                          style={{
                            fontSize: '20px',
                            fontWeight: activePage === 'notification' ? '700' : '500',
                            fontFamily,
                            cursor: 'pointer',
                            color:
                              activePage === 'notification' ? primaryColor || '#ED1C25' : 'black',
                            display: 'flex',
                            alignItems: 'center',
                            gap: '8px',
                          }}
                        >
                          <span>Notifications</span>
                          {notificationCount > 0 && (
                            <span
                              style={{
                                backgroundColor: primaryColor || '#ED1C25',
                                color: 'white',
                                fontSize: '11px',
                                fontWeight: '700',
                                borderRadius: '10px',
                                padding: '2px 6px',
                                display: 'inline-flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                minWidth: '20px',
                                height: '20px',
                                fontFamily,
                              }}
                            >
                              {notificationCount}
                            </span>
                          )}
                        </div>
                      </>
                    )}

                    <div
                      onClick={() => {
                        handleAbout();
                        setShowMenu(false);
                      }}
                      style={{
                        fontSize: '20px',
                        fontWeight: activePage === 'contact' ? '700' : '500',
                        fontFamily,
                        cursor: 'pointer',
                        color: activePage === 'contact' ? primaryColor || '#ED1C25' : 'black',
                      }}
                    >
                      Contact Us
                    </div>
                  </div>

                  {/* Footer */}
                  {loggedIn ? (
                    <div className="drawer-footer">
                      <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                        <div
                          style={{
                            width: '44px',
                            height: '44px',
                            borderRadius: '50%',
                            backgroundColor: '#ED1C25',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            color: 'white',
                          }}
                        >
                          <AccountCircleOutlinedIcon style={{ fontSize: '28px' }} />
                        </div>
                        <div style={{ display: 'flex', flexDirection: 'column' }}>
                          <span
                            style={{
                              fontSize: '15px',
                              fontWeight: '600',
                              color: '#000',
                              fontFamily,
                            }}
                          >
                            {`${userData?.data?.first_name || ''} ${userData?.data?.last_name || ''}`.trim() ||
                              'User'}
                          </span>
                          <span
                            style={{
                              fontSize: '12px',
                              color: '#666',
                              fontFamily,
                              wordBreak: 'break-all',
                            }}
                          >
                            {userData?.data?.user_email}
                          </span>
                        </div>
                      </div>
                      <button
                        onClick={() => {
                          handleProfile();
                          setShowMenu(false);
                        }}
                        style={{
                          backgroundColor: '#ED1C25',
                          color: 'white',
                          border: 'none',
                          borderRadius: '20px',
                          padding: '8px 16px',
                          fontSize: '13px',
                          fontWeight: '600',
                          cursor: 'pointer',
                          fontFamily,
                          whiteSpace: 'nowrap',
                        }}
                      >
                        My account
                      </button>
                    </div>
                  ) : (
                    <div className="drawer-footer">
                      <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                        <div
                          style={{
                            width: '44px',
                            height: '44px',
                            borderRadius: '50%',
                            backgroundColor: '#888',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            color: 'white',
                          }}
                        >
                          <AccountCircleOutlinedIcon style={{ fontSize: '28px' }} />
                        </div>
                        <div style={{ display: 'flex', flexDirection: 'column' }}>
                          <span
                            style={{
                              fontSize: '15px',
                              fontWeight: '600',
                              color: '#000',
                              fontFamily,
                            }}
                          >
                            Welcome, Guest
                          </span>
                        </div>
                      </div>
                      <button
                        onClick={() => {
                          handleLogin();
                          setShowMenu(false);
                        }}
                        style={{
                          backgroundColor: '#ED1C25',
                          color: 'white',
                          border: 'none',
                          borderRadius: '20px',
                          padding: '8px 16px',
                          fontSize: '13px',
                          fontWeight: '600',
                          cursor: 'pointer',
                          fontFamily,
                        }}
                      >
                        Sign In
                      </button>
                    </div>
                  )}
                </Drawer>
              </div>
            ) : (
              <div
                className={`grid gap-4 d-flex align-items-center ${
                  showMenu ? 'show-menu' : 'hide-menu'
                }`}
                style={{
                  justifyContent: 'space-evenly',
                  alignItems: 'center',
                }}
              >
                {!isAtAllEvents && (
                  <>
                    <div
                      className={`text-style nav-item ${activePage === 'home' ? 'active' : ''}`}
                      onClick={() => handleHome()}
                      style={{
                        color: activePage === 'home' ? primaryColor : FADE_BLACK,
                        fontFamily,
                        fontSize,
                        fontWeight,
                      }}
                    >
                      Home
                    </div>
                    <div
                      className={`text-style ${activePage === 'shop' ? 'active' : ''}`}
                      onClick={() => handleShop()}
                      style={{
                        color: activePage === 'shop' ? primaryColor : FADE_BLACK,
                        fontFamily,
                        fontSize,
                        fontWeight,
                      }}
                    >
                      Shop
                    </div>
                  </>
                )}
                <div
                  className={`text-style nav-item ${activePage === 'contact' ? 'active' : ''}`}
                  onClick={() => handleAbout()}
                  style={{
                    fontSize: fontSize || '1.1rem',
                    color: activePage === 'contact' ? primaryColor : FADE_BLACK,
                    fontFamily,
                    fontWeight,
                  }}
                >
                  Contact us
                </div>
                {/* <div
                  className={`text-style ${activePage === '/' ? 'active' : ''}`}
                  style={{
                    color: activePage === '/' ? primaryColor : FADE_BLACK,
                  }}
                >
                  <CustomButton
                    text="All Events"
                    size="sm"
                    onClick={() => handleAllEvents()}
                    className="py-1 px-3"
                    borderRadius={'5px'}
                  />
                </div> */}
                {!isAtAllEvents && (
                  <div
                    style={{
                      position: 'relative',
                      display: 'flex',
                      alignItems: 'center',
                      gap: '24px',
                    }}
                  >
                    {loggedIn && (
                      <div
                        style={{
                          position: 'absolute',
                          top: '0',
                          left: '0',
                          width: '40px',
                          height: '40px',
                          borderRadius: '50%',
                          backgroundColor: buttonColor || '#ED1C25',
                          transition:
                            'transform 0.3s cubic-bezier(0.4, 0, 0.2, 1), opacity 0.3s ease, scale 0.3s ease',
                          transform: `translateX(${activeIdx !== -1 ? activeIdx * (40 + 24) : 0}px)`,
                          opacity: activeIdx !== -1 ? 1 : 0,
                          transformOrigin: 'center',
                          scale: activeIdx !== -1 ? '1' : '0',
                          pointerEvents: 'none',
                          zIndex: 0,
                        }}
                      />
                    )}
                    <div
                      style={{
                        position: 'relative',
                        width: '40px',
                        height: '40px',
                        borderRadius: '50%',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        cursor: 'pointer',
                        zIndex: 1,
                      }}
                      onClick={handleCart}
                    >
                      <ShoppingCartOutlinedIcon
                        style={{
                          cursor: 'pointer',
                          color: loggedIn && activeIdx === 0 ? 'white' : 'black',
                          fontSize: '28px',
                          flexShrink: 0,
                          transition: 'color 0.3s ease',
                        }}
                      />
                      {cartBadgeValue > 0 && (
                        <span
                          style={{
                            position: 'absolute',
                            top: '0px',
                            right: '0px',
                            backgroundColor: primaryColor || PRIMARY,
                            height: '18px',
                            minWidth: '18px',
                            padding: '0 4px',
                            borderRadius: '9px',
                            fontSize: '10px',
                            fontWeight: fontWeight || 'bold',
                            color: 'white',
                            zIndex: 100,
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            fontFamily,
                          }}
                        >
                          {cartBadgeValue}
                        </span>
                      )}
                    </div>
                    {loggedIn ? (
                      <>
                        <div
                          style={{
                            position: 'relative',
                            width: '40px',
                            height: '40px',
                            borderRadius: '50%',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            cursor: 'pointer',
                            zIndex: 1,
                          }}
                          onClick={handleNotification}
                        >
                          <NotificationsNoneOutlinedIcon
                            onClick={() =>
                              handleUpdateNotification(
                                notifcation?.data.map(
                                  (notification) => notification.notification_id
                                )
                              )
                            }
                            style={{
                              cursor: 'pointer',
                              color: activeIdx === 1 ? 'white' : 'black',
                              fontSize: '28px',
                              flexShrink: 0,
                              transition: 'color 0.3s ease',
                            }}
                          />
                          {notificationCount > 0 && (
                            <span
                              style={{
                                position: 'absolute',
                                top: '0px',
                                right: '0px',
                                backgroundColor: primaryColor || PRIMARY,
                                height: '18px',
                                minWidth: '18px',
                                padding: '0 4px',
                                borderRadius: '9px',
                                fontSize: '10px',
                                fontWeight: fontWeight || 'bold',
                                color: 'white',
                                zIndex: 100,
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                                fontFamily,
                              }}
                              onClick={() =>
                                handleUpdateNotification(
                                  notifcation.data.map(
                                    (notification) => notification.notification_id
                                  )
                                )
                              }
                            >
                              {notificationCount}
                            </span>
                          )}
                        </div>

                        <div
                          onMouseEnter={handleOpenMenu}
                          onMouseLeave={handleCloseMenu}
                          style={{
                            display: 'inline-block',
                            position: 'relative',
                            cursor: 'pointer',
                          }}
                        >
                          <Tooltip
                            title={
                              `${userData?.data?.first_name || ''} ${userData?.data?.last_name || ''}`.trim() ||
                              userData?.data?.user_email ||
                              'Profile'
                            }
                          >
                            <Avatar
                              sx={{
                                bgcolor: 'transparent',
                                cursor: 'pointer',
                                color: activeIdx === 2 ? 'white' : 'black',
                                height: '40px',
                                width: '40px',
                                flexShrink: 0,
                                zIndex: 1,
                                transition: 'color 0.3s ease',
                              }}
                              onClick={handleOpenMenu}
                            >
                              <AccountCircleOutlinedIcon
                                style={{
                                  color: activeIdx === 2 ? 'white' : 'black',
                                  fontSize: '28px',
                                  transition: 'color 0.3s ease',
                                }}
                              />
                            </Avatar>
                          </Tooltip>
                          <Popper
                            open={Boolean(anchorEl)}
                            anchorEl={anchorEl}
                            placement="bottom-start"
                            style={{ zIndex: 1300 }}
                          >
                            <Paper
                              onMouseEnter={handleMenuMouseEnter}
                              onMouseLeave={handleCloseMenu}
                              style={{
                                marginTop: '5px',
                                backgroundColor: '#fff',
                                border: '1px solid #ccc',
                                borderRadius: '10px',
                                boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
                                minWidth: '220px',
                              }}
                            >
                              <div
                                style={{
                                  padding: '16px 20px',
                                  display: 'flex',
                                  alignItems: 'center',
                                  gap: '16px',
                                  borderBottom: '1px solid #eaeaea',
                                  backgroundColor: '#fff',
                                  width: '100%',
                                  boxSizing: 'border-box',
                                }}
                              >
                                <Avatar
                                  sx={{
                                    bgcolor: ORDERTHAT_RED,
                                    color: 'white',
                                    height: '42px',
                                    width: '42px',
                                    flexShrink: 0,
                                  }}
                                >
                                  <AccountCircleOutlinedIcon
                                    style={{ color: 'white', fontSize: '28px' }}
                                  />
                                </Avatar>
                                <div
                                  style={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    overflow: 'hidden',
                                  }}
                                >
                                  <span
                                    style={{
                                      fontSize: '15px',
                                      fontWeight: '600',
                                      color: '#1a1a1a',
                                      fontFamily: fontFamily || 'Poppins',
                                      whiteSpace: 'nowrap',
                                      overflow: 'hidden',
                                      textOverflow: 'ellipsis',
                                    }}
                                  >
                                    {`${userData?.data?.first_name || ''} ${userData?.data?.last_name || ''}`.trim() ||
                                      userData?.data?.user_email ||
                                      'General Admin'}
                                  </span>
                                  {userData?.data?.user_email && (
                                    <span
                                      style={{
                                        fontSize: '13px',
                                        color: '#727272',
                                        fontFamily: fontFamily || 'Poppins',
                                        whiteSpace: 'nowrap',
                                        overflow: 'hidden',
                                        textOverflow: 'ellipsis',
                                        marginTop: '2px',
                                      }}
                                    >
                                      {userData.data.user_email}
                                    </span>
                                  )}
                                </div>
                              </div>
                              <MenuList style={{ padding: 0 }}>
                                <MenuItem
                                  onClick={handleProfile}
                                  style={{
                                    padding: '14px 20px',
                                    width: '100%',
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '14px',
                                    borderBottom: '1px solid #f0f0f0',
                                    cursor: 'pointer',
                                  }}
                                >
                                  <AccountCircleOutlinedIcon
                                    style={{ color: '#5f6368', fontSize: '22px' }}
                                  />
                                  <span
                                    style={{
                                      fontSize: '15px',
                                      fontFamily: fontFamily || 'Poppins',
                                      color: '#333',
                                      fontWeight: '500',
                                    }}
                                  >
                                    My account
                                  </span>
                                </MenuItem>
                                {activeOrdersCount > 0 && (
                                  <MenuItem
                                    onClick={handleActiveOrders}
                                    style={{
                                      padding: '14px 20px',
                                      width: '100%',
                                      display: 'flex',
                                      alignItems: 'center',
                                      gap: '14px',
                                      borderBottom: '1px solid #f0f0f0',
                                      cursor: 'pointer',
                                    }}
                                  >
                                    <LocalActivityOutlinedIcon
                                      style={{ color: '#5f6368', fontSize: '22px' }}
                                    />
                                    <span
                                      style={{
                                        fontSize: '15px',
                                        fontFamily: fontFamily || 'Poppins',
                                        color: '#333',
                                        fontWeight: '500',
                                      }}
                                    >
                                      Active orders
                                    </span>
                                  </MenuItem>
                                )}
                                <MenuItem
                                  onClick={handleSignOut}
                                  style={{
                                    padding: '14px 20px',
                                    width: '100%',
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '14px',
                                    cursor: 'pointer',
                                  }}
                                >
                                  <LogoutIcon style={{ color: '#5f6368', fontSize: '22px' }} />
                                  <span
                                    style={{
                                      fontSize: '15px',
                                      fontFamily: fontFamily || 'Poppins',
                                      color: '#333',
                                      fontWeight: '500',
                                    }}
                                  >
                                    Sign out
                                  </span>
                                </MenuItem>
                              </MenuList>
                            </Paper>
                          </Popper>
                        </div>
                      </>
                    ) : (
                      <>
                        <div
                          onMouseEnter={handleOpenGetStarted}
                          onMouseLeave={handleCloseGetStarted}
                          style={{
                            display: 'inline-block',
                            position: 'relative',
                            cursor: 'pointer',
                          }}
                        >
                          <CustomButton
                            text="Get started"
                            size="sm"
                            onClick={handleOpenGetStarted}
                            className="py-1 px-3"
                            bgcolor={ORDERTHAT_RED}
                            colo={'#FFFFFF'}
                            borderRadius={'20px'}
                            style={{
                              fontWeight: 'bold',
                              fontSize: '16px',
                            }}
                          />
                          <Popper
                            open={Boolean(anchorElGetStarted)}
                            anchorEl={anchorElGetStarted}
                            placement="bottom-start"
                            style={{ zIndex: 1300 }}
                          >
                            <Paper
                              onMouseEnter={handleGetStartedMenuMouseEnter}
                              onMouseLeave={handleCloseGetStarted}
                              style={{
                                marginTop: '5px',
                                backgroundColor: '#fff',
                                border: '1px solid #ccc',
                                borderRadius: '10px',
                                boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
                                minWidth: '160px',
                              }}
                            >
                              <MenuList style={{ padding: 0 }}>
                                <MenuItem
                                  onClick={() => {
                                    setAnchorElGetStarted(null);
                                    handleLogin();
                                  }}
                                  style={{
                                    padding: '14px 20px',
                                    width: '100%',
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '14px',
                                    borderBottom: '1px solid #f0f0f0',
                                    cursor: 'pointer',
                                  }}
                                >
                                  <LoginIcon style={{ color: '#5f6368', fontSize: '22px' }} />
                                  <span
                                    style={{
                                      fontSize: '15px',
                                      fontFamily: fontFamily || 'Poppins',
                                      color: '#333',
                                      fontWeight: '500',
                                    }}
                                  >
                                    Sign in
                                  </span>
                                </MenuItem>
                                <MenuItem
                                  onClick={() => {
                                    setAnchorElGetStarted(null);
                                    handleRegister();
                                  }}
                                  style={{
                                    padding: '14px 20px',
                                    width: '100%',
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '14px',
                                    cursor: 'pointer',
                                  }}
                                >
                                  <PersonAddIcon style={{ color: '#5f6368', fontSize: '22px' }} />
                                  <span
                                    style={{
                                      fontSize: '15px',
                                      fontFamily: fontFamily || 'Poppins',
                                      color: '#333',
                                      fontWeight: '500',
                                    }}
                                  >
                                    Create account
                                  </span>
                                </MenuItem>
                              </MenuList>
                            </Paper>
                          </Popper>
                        </div>
                      </>
                    )}
                  </div>
                )}
              </div>
            )}
          </div>
        </div>
      </nav>
      <Dialog open={openDialog} onClose={() => setOpenDialog(false)} maxWidth="lg">
        <DialogTitle>Sign Out</DialogTitle>
        <DialogContent>
          <Typography>Are you sure you want to sign out?</Typography>
        </DialogContent>
        <DialogActions sx={{ justifyContent: 'center', padding: '30px' }}>
          <CustomButton
            onClick={handleLogout}
            text="Yes"
            size="sm"
            block={true}
            className="btn-sm"
            borderRadius={'30px'}
          />

          <CustomButton
            text="No"
            size="sm"
            block={true}
            className="btn-sm"
            bgcolor={'black'}
            colo={'white'}
            onClick={() => setOpenDialog(false)}
            borderRadius={'30px'}
          />
        </DialogActions>
      </Dialog>
    </>
  );
}
export default React.memo(Navbar);
